import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_household_dish: FaireCategoryEntity = {
  token: "cat_household-dish",
  type: "category",
  name: "Dishsoap & dishwasher",
  level: 3,
  parentToken: "cat_home-decor-household",
  href: "/category/home-decor/household-supplies-diy/dishsoap-dishwasher",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
